/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { getModelName, getEventModelList } from "data/resources/model-items-config";
import { Select, MenuItem, Switch } from "@mui/material";
import { getEventCategories, getSelectedCategoryName } from "data/resources/model-category-options";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
// import { Logger } from "cms/utils/log/logger";

const FeedCalendarComponentEditor = () => {

    const { component, update } = useUpdateComponent();
    const {
        selected_type: _selected_type,
        selected_category: _selected_category,
        enable_bar
    } = component || {};

    const [selectedType, setSelectedType] = useState(_selected_type);
    const [selectedCategory, setSelectedCategory] = useState(_selected_category);
    const [enableBar, setEnableBar] = useState(enable_bar ?? false);

    const model_types = getEventModelList();
    const category_types = getEventCategories(selectedType);

    const onChangeType = (event) => {
        const nextType = event.target.value;
        setSelectedType(nextType);
        update("selected_type", nextType);
    };
    
    const onChangeCategory = (event) => {
        let nextCategory = event.target.value;
        if (nextCategory === "none") {
            nextCategory = undefined;
        }
        setSelectedCategory(nextCategory);
        update("selected_category", nextCategory);
    };
    
    const onChangeToggle = (event) => {
        let nextChecked = event.target.checked;
        setEnableBar(nextChecked);
        update("enable_bar", nextChecked);
    };

    return (
        <div className="simplicity-editor-frame">
            <h3>Selected Model: {getModelName(selectedType)}</h3>
            <Select
                labelId={"type_label"}
                id="type-select"
                sx={{ width: "400px" }}
                value={selectedType}
                onChange={onChangeType}
            >
                <MenuItem key="none" value="none">Select One...</MenuItem>
                {model_types.map((type, index) => (
                    <MenuItem key={index} value={type.type}>{type.name}</MenuItem>
                ))}
            </Select>

            <h3>Selected Category: {getSelectedCategoryName(selectedType,selectedCategory)}</h3>
            <Select
                labelId={"category_label"}
                id="category-select"
                sx={{ width: "400px" }}
                value={selectedCategory}
                onChange={onChangeCategory}
            >
                {category_types.map((category, index) => (
                    <MenuItem key={index} value={category.type}>{category.name}</MenuItem>
                ))}
            </Select>

            <h3>Enable Search/Filter Bar:</h3>
            <Switch
                onChange={onChangeToggle}
                checked={enableBar}
            />

        </div>
    );
};

FeedCalendarComponentEditor.displayName = "FeedCalendarComponentEditor";
export { FeedCalendarComponentEditor };
